async function fetchDiscountedAddOnProductOffers(productHandle) {
  try {
    const response = await fetch(`/products/${productHandle}?view=metafields`);
  } catch (error) {}
}

const updateCartDynamicOffers = async (cart, updates, offers) => {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates,
        attributes: {
          _app_dynamic_offers_valid: offers.filter((o) => o.valid),
          _app_dynamic_offers_invalid: offers.filter((o) => !o.valid),
          _app_dynamic_offers_tags: "",
        },
      }),
    });

    const updatedCart = await response.json();
  } catch (error) {
    console.error("An error occurred:", error);
  }
};

const syncCartDynamicOffersAttributes = async (cart) => {
  try {
    // Retrieve dynamic offers from cart items' metafields
    // and filter out discounted add-on product offers
    const uniqueDynamicOffersArray =
      Array.from(
        cart.items.reduce((acc, cartItem) => {
          const appDynamicOffers = cartItem.metafields.app_dynamic_offers || [];
          appDynamicOffers.forEach((offer) => {
            acc.add(JSON.stringify(offer));
          });
          return acc;
        }, new Set())
      ).map((offerString) => JSON.parse(offerString)) || [];

    // Skip the fetch if there are no dynamic offers to sync
    if (uniqueDynamicOffersArray.length === 0) return;

    const updates = {};

    uniqueDynamicOffersArray.map((offer) => {
      const type = offer.type;
      const message = offer.fields.message;
      const valid = offer.valid || true;
      offer.valid = valid;
    });

    await updateCartDynamicOffers(cart, updates, uniqueDynamicOffersArray);
  } catch (error) {
    console.error("An error occurred:", error);
  }
};

/**
 * Synchronizes and logs valid discounted add-on product offers for a given cart item.
 *
 * @param {Object} cart - The cart containing the item to check for valid offers.
 * @param {Object} item - The cart item to check for valid offers.
 * @returns {Promise<void>} - A promise that resolves when the operation is complete.
 */
const synchroniseDiscountedAddOnProductOffers = async (itemId) => {
  try {
    const response = await fetch("/cart?view=items");
    const cart = await response.json();
    const item = cart.items.find((i) => parseInt(i.id) === parseInt(itemId));

    // Retrieve dynamic offers from cart items' metafields
    // and filter out discounted add-on product offers
    const uniqueDynamicOffersArray =
      Array.from(
        cart.items.reduce((acc, cartItem) => {
          const appDynamicOffers = cartItem.metafields.app_dynamic_offers || [];
          appDynamicOffers.forEach((offer) => {
            acc.add(JSON.stringify(offer));
          });
          return acc;
        }, new Set())
      ).map((offerString) => JSON.parse(offerString)) || [];
    const updates = {};

    uniqueDynamicOffersArray.map((offer) => {
      const type = offer.type;
      const message = offer.fields.message;
      const valid = offer.valid || true;
      offer.valid = valid;

      const appliesTo = offer.applies_to || [];
      if (type === "discounted_add_on_product_offer") {
        const itemDynamicOffers = item.metafields.app_dynamic_offers || [];
        const oncePerCart = offer.fields.once_per_cart;
        const addAllProducts = offer.fields.add_all_products;
        const quantity = offer.fields.quantity;
        const discountedAddOns =
          offer.discounted_add_on_products.first_available_variants || [];

        const hasOffer = itemDynamicOffers.some(
          (o) => o.id === offer.id && o.type == offer.type
        );
        if (hasOffer) {
          for (let i = 0; i < discountedAddOns.length; i++) {
            const addOn = discountedAddOns[i];
            let updatedQty = oncePerCart
              ? addOn.cart_quantity - quantity
              : addOn.cart_quantity + quantity;
            if (updatedQty == 0 && oncePerCart) {
              updatedQty = 1;
            }
            if (updatedQty < 0) {
              updatedQty = updatedQty * -1;
            }
            updates[addOn.id] = updatedQty;
            if (!addAllProducts) {
              break;
            }
          }
        }
      }
    });

    await updateCartDynamicOffers(cart, updates, uniqueDynamicOffersArray);
  } catch (error) {
    console.error("An error occurred:", error);
  }
};

const isEqualObjects = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = obj1[key];
    const val2 = obj2[key];
    const areObjects = typeof val1 === "object" && typeof val2 === "object";

    if (
      (areObjects && !isEqualObjects(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
};

const initVariantSelector = async (selector) => {
  selector.setAttribute("data-listener", "true");
  selector.addEventListener("change", async (event) => {
    const item = JSON.parse(event.target.getAttribute("data-item"));
    const cart = await handleVariantSelector(item, selector);
  });
};

const handleVariantSelector = async (item, selector) => {
  try {
    // Send the updates to the server to update the cart quantities
    const updateResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [item.key]: 0,
        },
      }),
    });

    // Parse the updated cart response
    const cart = await updateResponse.json();
    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: selector.value,
        quantity: item.quantity,
      }),
    });
    const addedCart = await addResponse.json();
    document.body.dispatchEvent(new CustomEvent("updateCartDrawer"));

    // Return the updated cart object
    return addedCart;
  } catch (error) {
    // Log any errors that occur during the process
    console.error("Error handling discounted add-on product offer:", error);
  }
};
